import { useQuery } from '@tanstack/react-query';
import { SourcingService } from 'api-clients/monolith';

import { queryKeys } from '@/query-keys';

import { questionnaireFacet } from '../direct-apply-questionnaire';
import type { PostingRequirementsDef } from '../requirements-key';

/**
 * Hire's Direct Apply questionnaire preview for one opening and board. It
 * loads as soon as the board has a questionnaire facet, before Direct Apply is
 * selected, and stays cached until the page reloads: Hire refuses an order
 * whose questions changed since.
 */
export function useQuestionnairePreview(
  openingId: string,
  def: PostingRequirementsDef,
  productId: string | undefined,
) {
  const facet = questionnaireFacet(def);

  return useQuery({
    queryKey: queryKeys.jobPosting.questionnairePreview(openingId, def.key),
    queryFn: () =>
      SourcingService.postInternalApiSourcingVonqDirectApplyQuestionnaire({
        opening_id: openingId,
        product_id: productId ?? '',
        contract_id: def.source === 'contract' ? def.sourceId : null,
        facet: facet?.name ?? '',
      }),
    enabled: Boolean(facet && productId),
    staleTime: Infinity,
  });
}
